import React, { PureComponent, ReactNode } from "react"
import StyledArticle from "./styles"
import { Page } from "../../../components"
import { appsStyleSelected } from "../../../helpers/app"
import { LiteralsService } from "../../../services"
import { DispatchProp } from "react-redux"
import { connectRedux } from '../../../helpers/connectRedux'
import { IStoreState } from "../../../store/states"
import { resetNewReservationFieldsAction } from "../../../store/actions"
import { urls } from "../../../routing"
import { Application } from "../../../config"
import { RouteComponentProps, withRouter } from "../../../helpers/withRouter"
import { AnyAction } from 'redux'
import { restartIframeBooking } from '../../../helpers'

const { isIframe } = Application

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  userCreated: boolean
}

class CompletedStep extends PureComponent<IProps> {

  constructor(props: IProps) {
    super(props)
  }

  public componentDidMount(): void {
    window.history.pushState(null, '', window.location.href)
    window.addEventListener('popstate', this.handleBack)
  }

  public componentWillUnmount(): void {
    window.removeEventListener('popstate', this.handleBack)
  }

  private handleBack = () => {
    if (isIframe) {
      restartIframeBooking()
      return
    }
    const { dispatch, history } = this.props
    dispatch(resetNewReservationFieldsAction())
    history.replace(urls.newReservationBusStopsStep)
  }

  public getWebAppURL = () => {
    return `webapp${process.env.REACT_APP_SUFIX ?? ''}.nemi.mobi`
  }

  public render(): ReactNode {
    const { userCreated } = this.props
    return (
      <Page className={`${appsStyleSelected?.style}`}>
        <StyledArticle>
          <div className="text-container">
            <div className="title">
              { LiteralsService.get('bookCompleted.title', true) }
            </div>
            <div className="subtitle">
              { LiteralsService.get('bookCompleted.ticketCompletedMessage', true) }
              <a href={`https://${this.getWebAppURL()}`} target="_blank">
                { this.getWebAppURL() }
              </a>
            </div>
            {
              userCreated &&
              <div className="reminder">
                { LiteralsService.get('bookCompleted.newUserReminder', true) }
              </div>
            }
          </div>
        </StyledArticle>
      </Page>
    )
  }
}

const mapStateToProps = ({ newReservation }: IStoreState) => ({
  userCreated: newReservation.userCreated
})

export default withRouter(connectRedux(mapStateToProps, CompletedStep as any))
